import { useState } from 'react'
import useScript from 'react-script-hook'
import {
  useGetGoogleCalendarAuthSettingsQuery,
  useGetUserGoogleCalendarApiAuthenticatedQuery,
  useRevokeCredentialsForGoogleCalendarApiMutation,
  useSetCredentialsForGoogleCalendarApiMutation
} from '../../pages/user/operations/UserAuthentication.codegen'

export const useGoogleAuth = (skip: boolean = false) => {
  if (skip) {
    return {
      isAuthenticated: false,
      revoke: () => console.error('useGoogleAuth hook was skipped'),
      authenticate: () => console.error('useGoogleAuth hook was skipped')
    }
  }
  const [isLoaded, setIsLoaded] = useState(false)
  const { data, refetch } = useGetUserGoogleCalendarApiAuthenticatedQuery()
  const isAuthenticated = data?.me.isGoogleCalendarAPIAuthenticated
  const [setCredentialsForGoogleCalendarApi] =
    useSetCredentialsForGoogleCalendarApiMutation()

  useScript({
    src: 'https://apis.google.com/js/api.js',
    onload: () => {
      onApiLoad()
      setIsLoaded(true)
    }
  })

  const [revokeCredentialsForGoogleCalendarApi] =
    useRevokeCredentialsForGoogleCalendarApiMutation()

  const { data: googleSettingsDataReq } =
    useGetGoogleCalendarAuthSettingsQuery()

  const settings: { scope: string; clientId: string } =
    googleSettingsDataReq?.admin?.getGoogleCalendarAuthSettings

  const onApiLoad = () => {
    window.gapi.load('auth2')
  }

  const authenticate = async () => {
    if (!isLoaded) {
      return null
    }

    const auth = window.gapi.auth2

    const res = await auth
      .init({
        client_id: settings.clientId,
        scope: settings.scope
      })
      .grantOfflineAccess()

    if (res.code) {
      const { data } = await setCredentialsForGoogleCalendarApi({
        variables: {
          authCode: res.code
        }
      })

      if (data && data.me?.setCredentialsForGoogleCalendarApi) {
        await refetch()
        return data?.me?.setCredentialsForGoogleCalendarApi
      }
    }

    return false
  }

  const revoke = async () => {
    if (!isLoaded) {
      return null
    }

    const { data } = await revokeCredentialsForGoogleCalendarApi()

    if (data && data.me?.revokeCredentialsForGoogleCalendarApi) {
      refetch()
    }
  }

  return { isAuthenticated, authenticate, revoke }
}
